import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=dbb46030&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"
import style0 from "./Research.vue?vue&type=style&index=0&id=dbb46030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb46030",
  null
  
)

export default component.exports